import React from 'react';
import { Note } from 'types/notes';
import { isNoteViewedToday } from 'utils/dailyViewTracker';

interface NotesIndexNoteItemProps {
  note: Note;
  compact?: boolean;
};

const NotesIndexNoteItem = ({ note, compact }: NotesIndexNoteItemProps) => {
  const note_url = `/notes/${note.uid || note.id}`;
  const isViewed = isNoteViewedToday(note.id);

  if (compact) {
    return (
      <div className="flex gap-3 border-b border-gray-200 py-3 cursor-pointer relative hover:bg-gray-50">
        {isViewed && (
          <div className="absolute top-2 right-2 z-10 bg-green-500 text-white text-xs px-2 py-0.5 rounded-full">
            ✓읽음
          </div>
        )}
        <a href={note_url} className="shrink-0">
          {note.image_url ?
            <img src={note.image_url} alt={note.title} className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded" /> :
            <div className="w-20 h-20 sm:w-24 sm:h-24 bg-gray-200 rounded flex items-center justify-center text-gray-400 text-xs">No Image</div>
          }
        </a>
        <div className="flex-1 min-w-0">
          <h2 className="text-sm sm:text-base font-semibold text-gray-800 line-clamp-2">
            <a href={note_url}>{note.title}</a>
          </h2>
          <p className="text-xs sm:text-sm text-gray-500 mt-1 line-clamp-2">
            {note.description}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="card bg-base-100 shadow-xl min-h-[6rem] w-full md:w-80 bg-cover bg-top cursor-pointer relative">
      {isViewed && (
        <div className="absolute top-2 right-2 z-10 bg-green-500 text-white text-xs px-2 py-1 rounded-full">
          ✓읽음
        </div>
      )}
      <figure className="min-h-[14rem] max-h-[14rem] overflow-hidden p-0 mb-0 flex flex-col items-start not-prose block">
        <a href={note_url}>
        { note.image_url ?
          <img src={note.image_url} alt={note.title} className={isViewed ? '' : ''} /> :
          <img src="https://placehold.co/400x300" alt={note.title} className={isViewed ? '' : ''} />
        }
        </a>
      </figure>
      <div className="card-body p-4 flex flex-col justify-between">
        <div>
          <h2 className="card-title text-lg mb-2 text-gray-800">
            <a href={note_url}>{note.title}</a>
          </h2>
          <p className="text-sm mb-4 line-clamp-3 text-gray-800">
            {note.description}
          </p>
        </div>
        <div className="card-actions justify-end text-sm text-gray-400">
        </div>
      </div>
    </div>
  );
};

export default NotesIndexNoteItem;
